module.exports = __webpack_public_path__ + "static/img/s5.5c822738.png";